import { registerContainerUIElement, registerUIElement } from '@/stores/UIElementStorage';

import { ContainerCfgUIElementState } from '@/stores/ContainerCfgUIElementState';
import { ComponentCfgUIElementState } from '@/stores/ComponentCfgUIElementState';
import { RalAttributeCfgUIElementState } from '@/stores/RalAttributeCfgUIElementState';
import { ProductCfgUIElementState } from '@/stores/ProductCfgUIElementState';
import { ProductsContainerCfgUIElementState } from '@/stores/ProductsContainerCfgUIElementState';
import { ComponentsContainerCfgUIElementState } from '@/stores/ComponentsContainerCfgUIElementState';
import { AttributesContainerCfgUIElementState } from '@/stores/AttributesContainerCfgUIElementState';
import { CompositeProductInfoCfgUIElementState } from '@/stores/CompositeProductInfoCfgUIElementState';
import { TextAttributeCfgUIElementState } from '@/stores/TextAttributeCfgUIElementState';
import { HtmlBlockUIElementState } from '@/stores/HtmlBlockUIElementState';
import {
  IUICfgAttributeBoolean,
  IUICfgAttributeDecimal,
  IUICfgAttributeInteger,
  IUICfgAttributeRal,
  IUICfgAttributeText,
  IUICfgComponent,
  IUICfgProduct,
  IUICfgUICompositeProductInfoElementUI,
  IUICfgUIHtmlBlockUIElement,
} from '@canvas-logic/clp-api-types';
import { DecimalAttributeCfgUIElementState } from './stores/DecimalAttributeCfgUIElementState';
import { BooleanAttributeCfgUIElementState } from './stores/BooleanAttributeCfgUIElementState';
import { IntegerAttributeCfgUIElementState } from './stores/IntegerAttributeCfgUIElementState';

registerUIElement<IUICfgAttributeRal>('attribute', 'RAL', {
  init: ({ api, viewElement }) => {
    return new RalAttributeCfgUIElementState(api, viewElement);
  },
});
registerUIElement<IUICfgAttributeText>('attribute', 'text', {
  init: ({ api, viewElement }) => {
    return new TextAttributeCfgUIElementState(api, viewElement);
  },
});

registerUIElement<IUICfgAttributeBoolean>('attribute', 'boolean', {
  init: ({ api, viewElement }) => {
    return new BooleanAttributeCfgUIElementState(api, viewElement);
  },
});
registerUIElement<IUICfgAttributeInteger>('attribute', 'integer', {
  init: ({ api, viewElement }) => {
    return new IntegerAttributeCfgUIElementState(api, viewElement);
  },
});
registerUIElement<IUICfgAttributeDecimal>('attribute', 'decimal', {
  init: ({ api, viewElement }) => {
    return new DecimalAttributeCfgUIElementState(api, viewElement);
  },
});
registerUIElement<IUICfgComponent>('component', 'default', {
  init: ({ api, viewElement }) => {
    return new ComponentCfgUIElementState(api, viewElement);
  },
});

registerUIElement<IUICfgProduct>('product', 'default', {
  init: ({ api, viewElement, componentSettings }) => {
    return new ProductCfgUIElementState(api, viewElement, componentSettings);
  },
});

registerUIElement<IUICfgUIHtmlBlockUIElement>('ui-element', 'HTMLBlock', {
  init: ({ viewElement }) => {
    return new HtmlBlockUIElementState(viewElement);
  },
});

registerContainerUIElement('container', 'default', {
  init: ({ api, viewElement, children }) => {
    return new ContainerCfgUIElementState(children, viewElement);
  },
});

registerContainerUIElement('container', 'element-container', {
  init: ({ api, viewElement, children }) => {
    return new ContainerCfgUIElementState(children, viewElement);
  },
});

registerContainerUIElement('container', 'products-container', {
  init: ({ api, viewElement, children }) => {
    return new ProductsContainerCfgUIElementState(children, viewElement);
  },
});

registerContainerUIElement('container', 'components-container', {
  init: ({ api, viewElement, children }) => {
    return new ComponentsContainerCfgUIElementState(children, viewElement);
  },
});

registerContainerUIElement('container', 'attributes-container', {
  init: ({ api, viewElement, children }) => {
    return new AttributesContainerCfgUIElementState(children, viewElement);
  },
});

registerUIElement<IUICfgUICompositeProductInfoElementUI>('ui-element', 'composite-product-info', {
  init: ({ api, viewElement }) => {
    return new CompositeProductInfoCfgUIElementState(api, viewElement);
  },
});
